import { timeStringToMs } from '../../utility/DateFormatter';
import { IAssetImagesV5, IAssetStreamV5, IAssetTextsV5, IAssetV5, ICredit } from '../../../api/models/AndromeTV.types';

export class VodAsset implements IAssetV5 {
  constructor(asset: IAssetV5) {
    // Object.assign(this, asset); //TODO find a way to do this without manually having to copy every member and still have jsdoc not complain
    this.assetId = asset.assetId;
    this.assetType = asset.assetType;
    this.text = asset.text;
    this.image = asset.image;
    this.adult = asset.adult;
    this.minimumAge = asset.minimumAge;
    this.parentalRatings = asset.parentalRatings;
    this.duration = asset.duration;
    this.episodeNumber = asset.episodeNumber;
    this.seasonNumber = asset.seasonNumber;
    this.seasonId = asset.seasonId;
    this.seriesId = asset.seriesId;
    this.credits = asset.credits;
    this.productionYear = asset.productionYear;
    this.productionLocations = asset.productionLocations;
    this.categoryTags = asset.categoryTags;
    this.genres = asset.genres;
    this.streams = asset.streams;
    this.validFrom = asset.validFrom;
    this.validUntil = asset.validUntil;
    this.score = asset.score;
    this.operatorScore = asset.operatorScore;
    this.catalogs = asset.catalogs;
    this.parentalControl = asset.parentalControl;
  }

  assetId: string;
  assetType: string;
  text: IAssetTextsV5;
  image: IAssetImagesV5;
  adult: boolean;
  minimumAge?: number;
  parentalRatings?: string[];
  duration?: number;
  episodeNumber?: number;
  seasonNumber?: number;
  seasonId?: string;
  seriesId?: string;
  credits?: ICredit[];
  productionYear?: number;
  productionLocations?: string[];
  categoryTags?: string[];
  genres?: string[];
  streams?: IAssetStreamV5[];
  validFrom?: string;
  validUntil?: string;
  score: number;
  operatorScore: number;
  catalogs?: string[];
  parentalControl: string;

  isExpired() {
    const now = new Date().getTime();
    const from = this.validFrom ? timeStringToMs(this.validFrom) : undefined;
    const until = this.validUntil ? timeStringToMs(this.validUntil) : undefined;
    return from && until && (until < now || from > now);
  }
}
